var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIconWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.313,
    height: 21.289,
    viewBox: "0 0 21.313 21.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822",
    transform: "translate(24782.733 -151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6979",
    "data-name": "Path 6979",
    d: "M223.974,17.736a5.733,5.733,0,0,1,2.775-.71,5.9,5.9,0,0,1,3.619,1.243l.089.067,2.486-2.064,1.376,1.643.111-.133a1.143,1.143,0,0,0,.067-1.443,1.182,1.182,0,0,0-1.421-.178l-.111.044-.089-.089a7.088,7.088,0,0,0-.821-.644l-.155-.2c-1.2-1.688-1.82-2.531-4.018-2.908a2.532,2.532,0,0,0-.6-.044c-2.02,0-4,1.665-5.017,2.642l-.089.044c-.089.067-.2.111-.289.178l-.133.089,2.131,2.531Zm.111-3.574a5.913,5.913,0,0,1,3.2-1.288,3.312,3.312,0,0,1,.488.044,4.2,4.2,0,0,1,3.019,1.776,9.165,9.165,0,0,0-6.7-.533Z",
    transform: "translate(-24998.957 138.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6980",
    "data-name": "Path 6980",
    d: "M468.258,157.76a4.3,4.3,0,0,0-1.865-3.619c-.2-.178-.4-.377-.622-.577a9.967,9.967,0,0,0-.577-1.088l-.089-.155-2.531,2.131.044.111a5.841,5.841,0,0,1-.555,6.394l-.067.089,2.131,2.531.111-.111a8.649,8.649,0,0,0,.932-1.243c1.421-1.021,3.041-2.442,3.064-4.307Zm-.555.133a4.284,4.284,0,0,1-1.843,3.064,9.149,9.149,0,0,0,.377-6.194,3.5,3.5,0,0,1,1.465,3.064Z",
    transform: "translate(-25229.678 4.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6981",
    "data-name": "Path 6981",
    d: "M161.142,393.742a5.733,5.733,0,0,1-2.775.71,5.9,5.9,0,0,1-3.619-1.243l-.089-.089-2.4,2.02-1.332-1.576-.111.133a1.143,1.143,0,0,0-.067,1.443,1.182,1.182,0,0,0,1.421.178l.044.044c.089.067.155.133.244.2l.067.067c1.2,1.687,3.041,3.663,5.106,3.685,2.176,0,2.775-.6,4.085-1.887l.688-.688a8.65,8.65,0,0,0,.8-.444l.133-.089-2.131-2.531Zm-2.8,3.974a9.3,9.3,0,0,0,2.708-.4,3.811,3.811,0,0,1-3.352,1.443h-.044c-1.332,0-2.619-1.11-3.508-2.065A9.15,9.15,0,0,0,158.345,397.716Z",
    transform: "translate(-24930.555 -227.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6982",
    "data-name": "Path 6982",
    d: "M173.144,76.967l1.665-1.421-.133-.111a1.173,1.173,0,0,0-1.443-.067,1.146,1.146,0,0,0-.178,1.421Z",
    transform: "translate(-24952.037 78.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6983",
    "data-name": "Path 6983",
    d: "M480.465,436.24l-1.665,1.421.133.111a1.42,1.42,0,0,0,.821.289.892.892,0,0,0,.622-.222,1.146,1.146,0,0,0,.178-1.421Z",
    transform: "translate(-25245.816 -268.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6984",
    "data-name": "Path 6984",
    d: "M85.224,132.774l2.531-2.131-.044-.111a5.881,5.881,0,0,1,.533-6.394l.067-.089-2.131-2.531-.111.111a7.093,7.093,0,0,0-.488.6c-.266.2-.533.377-.755.555-1.465,1.043-2.087,1.487-2.442,3.619a3.444,3.444,0,0,0-.067.688,8.106,8.106,0,0,0,2.531,5.15l.089.089c.067.111.111.2.178.311Zm-2.331-5.683a5.424,5.424,0,0,1,.044-.6,3.618,3.618,0,0,1,1.82-2.975,9.176,9.176,0,0,0-.622,6.971A6.336,6.336,0,0,1,82.893,127.091Z",
    transform: "translate(-24865.049 33.81)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconWaiting);
export default __webpack_public_path__ + "static/media/helpIconWaiting.6c7beeee.svg";
export { ForwardRef as ReactComponent };